// Site content, edited through the admin page at /admin (Decap CMS).
// Each JSON file here is one editable section; see public/admin/config.yml.
import bioJson from './bio.json';
import musicJson from './music.json';
import membersJson from './members.json';
import showsJson from './shows.json';
import galleryJson from './gallery.json';
import siteJson from './site.json';
import layoutJson from './layout.json';
import { Layout, normalizeLayout } from './layout';

export interface BioContent {
  text: string;
  backgroundImage?: string;
}

export interface Video {
  title?: string;
  url: string;
}

export interface BandcampAlbum {
  title?: string;
  embedUrl: string;
  albumUrl?: string;
}

export interface SpotifyEmbed {
  title?: string;
  url: string;
}

export interface MusicContent {
  videos?: Video[];
  bandcamp?: BandcampAlbum[];
  spotify?: SpotifyEmbed[];
}

export interface BandMember {
  name: string;
  role?: string;
  image?: string;
  bio?: string;
}

export interface Show {
  date: string; // YYYY-MM-DD
  venue: string;
  location?: string;
  ticketUrl?: string;
  poster?: string;
}

export interface Photo {
  image: string;
  alt?: string;
}

export interface SiteContent {
  logo?: string;
  contactEmail?: string;
  socials?: Partial<
    Record<'facebook' | 'twitter' | 'instagram' | 'youtube' | 'tiktok' | 'bandcamp' | 'spotify', string>
  >;
}

/** Everything on the page, one key per editable section. */
export interface SiteData {
  bio: BioContent;
  music: MusicContent;
  shows: Show[];
  members: BandMember[];
  gallery: Photo[];
  site: SiteContent;
  layout: Layout;
}

export const bio: BioContent = bioJson;
export const music: MusicContent = musicJson;
export const members: BandMember[] = membersJson.members ?? [];
export const shows: Show[] = showsJson.shows ?? [];
export const gallery: Photo[] = galleryJson.photos ?? [];
export const site: SiteContent = siteJson;

export const layout: Layout = normalizeLayout(layoutJson);

/** The content baked into this build (what the public site shows). */
export const defaultContent: SiteData = { bio, music, shows, members, gallery, site, layout };
